import React from "react";
import Input from "../Components/Input";

const SizeRow = ({
  size,
  sizeIdx,
  handleCheckChange,
  handlePriceChange,
  handleCostChange,
  handleCustomNameChange,
}) => {

  return (
    <div className="flex">
      {size.index ? (
        <div className="w-1/3 text-left text-xs pl-5">
          <input
            type="checkbox"
            checked={!!size.isToBeAdded}
            onChange={() => {
              handleCheckChange(sizeIdx, !size.isToBeAdded);
            }}
          />{" "}
          {size.name}
        </div>
      ) : (
        <div className="w-1/3 px-2">
          <Input
            name={sizeIdx}
            id="sizeOther"
            onChange={handleCustomNameChange}
            value={size.size_other}
          />
        </div>
      )}
      <div className="w-1/3 px-2">
        <Input
          disabled={!size.isToBeAdded}
          name={sizeIdx}
          id="altPrice"
          onChange={handlePriceChange}
          value={size.altPrice}
        />
      </div>
      <div className="w-1/3 px-2">
        <Input
          disabled={!size.isToBeAdded}
          name={sizeIdx}
          id="altCost"
          onChange={handleCostChange}
          value={size.altCost}
        />
      </div>
    </div>
  );
};

export default SizeRow;

